import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/modules/project/services/project.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit{
    projectId!: string;
    userId!: string;
    status!: number; // Status will be retrieved from the URL
    id!:string;
    invitationMessage!: string;
    constructor(
      private activeRoute: ActivatedRoute, 
      private project: ProjectService,
      private router : Router,
      private localStorageService: LocalStorageService
    ) {}
    isLoading : boolean = false
  
    ngOnInit(): void {
      // Get query parameters for rejection
      this.activeRoute.queryParams.subscribe(params => {
        this.projectId = params['project_id'];
        this.userId = params['user_id'];
        this.status = params['status']; // Retrieve the status from the URL
        this.id=this.projectId
        this.localStorageService.set('invite_user_id',this.userId);
        if (this.projectId && this.userId && this.status) {         
          this.acceptProject();
        }
      });
    }
  
    /**
     * Accept project
     */
    acceptProject(): void {
      this.isLoading = true
      this.project.getAcceptUserStatus(this.projectId, this.userId, this.status).subscribe({
        next: (response: any) => {          
            // Success response handling
            this.invitationMessage = response.message; // "Your invitation has been accepted"
            this.isLoading = false
          
        },
        error: (error: any) => {
        // Handle error response
          this.invitationMessage = error.error.message;
          this.isLoading = false
       
        },
      });
    }
}
